import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/capacitor';
import * as SentryAngular from '@sentry/angular-ivy';

if (environment.type === 'production') {
  Sentry.init(
    {
      dsn: 'https://f87d7d1e53d8a8c3daa2446f1455338c@o1422510.ingest.us.sentry.io/4507192991940608',
      integrations: [
        new SentryAngular.BrowserTracing({
          tracePropagationTargets: ['localhost', environment.api_url],
          routingInstrumentation: SentryAngular.routingInstrumentation,
        }),
        new SentryAngular.Replay(),
      ],
      tracesSampleRate: 1.0,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      ignoreErrors: [
        '/Http failure response for https:\/\/bubba-dashboard-admin-prod\.wibodev\.com\/users\/me: 401 OK/',
        '/Http failure response for .*: 0 Unknown Error$/',
        '/Object captured as exception with keys:/'
      ],
    },
    SentryAngular.init
  );
}

const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule);

if (environment.production) {
  enableProdMode();
}

if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
  navigator.serviceWorker.controller.postMessage({
    action: 'UPDATE_CACHE',
    version: environment.version,
  });
}
// .catch(err => console.error(err));

bootstrap().catch((err) => console.error(err));
